export class CreateOrder {
  public WarehouseId: number;
  public PhotographerId: number;
  public Comments: string;
  public CompanyId: number;
  public EndDate: string;
  public StylesColorsSizes: Array<ModelColorSize>;

  constructor(init?: Partial<CreateOrder>) {
    Object.assign(this, init);
  }
}

export class ModelColorSize {
  modelId: number;
  colorId: number;
  sizeGroupId?: number;

  constructor(init?: Partial<ModelColorSize>) {
    Object.assign(this, init);
  }
}
